import React from 'react';
import PageTitle from '../../components/PageTitle';
import {
  FormWrapper,
  FlexWrapper,
  MovingIcon,
  ContactMail,
  ControlP,
} from '../styles';

const LandlordControl = () => (
  <div>
    <PageTitle>Hyresvärdarna hanterar ansökan</PageTitle>
    <FormWrapper>
      <FlexWrapper mobileColumn>
        <FlexWrapper flex="column" mobileCentered mobileColumn flexPart={2}>
          <h2>Ditt ärende hanteras hos hyresvärdarna</h2>
          <ControlP>
            Nu är bytet inskickat till hyresvärdarna och deras handläggning tar
            vid. Det är olika hos olika hyresvärdar vad gäller handläggningstid.
          </ControlP>
          <ControlP>
            Bytesparterna kontaktas direkt av hyresvärdarna så snart
            handläggningen är klar eller om kompletteringar efterfrågas.
          </ControlP>
          <ControlP>
            Enligt vår erfarenhet så tar ett byte i snitt 6-8 veckor. Ibland så
            kan det gå snabbare men ibland kan det också ta längre tid.
          </ControlP>
          <ControlP>
            När bytet väl är inskickat till hyresvärdarna så har vi på
            Bytesansökan inga möjligheter att påverka handläggningstiden.
          </ControlP>
          <ControlP>
            Alla frågor gällande inflyttning, kontrakt, godkännande, hyror mm
            tas direkt med hyresvärden och inte via Bytesansökan.
          </ControlP>
          <ControlP bold>
            Har du några frågor så tveka inte att höra av dig!
          </ControlP>
          <ContactMail small to="bytesansokan@lagenhetsbyte.se">
            bytesansokan@lagenhetsbyte.se
          </ContactMail>
        </FlexWrapper>
        <FlexWrapper centered flexPart={1}>
          <MovingIcon />
        </FlexWrapper>
      </FlexWrapper>
    </FormWrapper>
  </div>
);

export default LandlordControl;



// WEBPACK FOOTER //
// ./src/views/LandlordControl/index.js